import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = () => {
  return (
    <Grid justify="space-between">
      <Col flex={1}>
        <Title size="h5" noMargin>
          {'Itens do agrupamento'}
        </Title>
      </Col>
    </Grid>
  )
}

export default ModalHeader
